
import { Table, Stack, TableBody, TableCell, TableContainer, TableHead, Tabs, Tab, TableRow, Box, Divider, Grid, Typography, Tooltip, Autocomplete, TextField, InputAdornment, useTheme, Button, Toolbar, IconButton, Collapse, Chip } from "@mui/material";

import { styled } from '@mui/material/styles';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import React, { useState, useEffect } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import PreviewPurchaseIndentEmail from "../purchase-indent/PreviewPurchaseIndentEmail";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';

import CallAlertBar from "../../../Layout/Alertbar";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import useDepartment from "../../../hooks/useDepartment";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";

import useEmployee from "../../../hooks/useEmployee";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import usePurchaseIndentNumber from "../../../hooks/usePurchaseIndentNumber";

import SwipeableViews from 'react-swipeable-views';


import MaterialWiseVendor from "../vendor/MaterialWiseVendor";

import useVendorEnquiryCRUD from "../../../hooks/useVendorEnquiryCRUD";
import useLoadVendorEnquiryDetailByVendor from "../../../hooks/useLoadVendorEnquiryDetailByVendor";
import VendorEnquiryActionMenu from "./VendorEnquirySubMenu";


import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import MultiVendorEnquiryPDF from "./MultiVendorEnquiryPDF";
import AddVendorResponse from "../vendor-quotation/AddVendorResponse";
import VendorEnquiryMail from "./VendorEnquiryMail";
import { IconBase } from "react-icons/lib";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import AddVendorReponseNew from "../vendor-quotation/AddVendorReponseNew";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const AddNewVendorEnquiry = ({ handlecallback, editIssueIndentID: editPurchaseIndentID, selectedMode, idDepartment, idRequestIndent, callfromPurchaseIndent = false }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Parent Roll  Alert Values
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [openPreviewModal, setOpenPreviewModal] = useState(false);
    const [value, setValue] = React.useState(0);
    const [vendors, setVendors] = useState([]);
    const [requestedDate, setRequestedDate] = useState(dayjs());
    const [openRow, setOpenRow] = useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [openVendorEnquiry, setOpenVendorEnquiry] = useState(true);
    const [openVendorQuotation, setOpenVendorQuotation] = useState(false);
    const [EnquiryAllowed, setEnquiryAllowed] = useState(true);


    const [editIssueIndentID, setEditIssueIndentID] = useState(0);
    const [editpurchaseindentID, setEditpurchaseindentID] = useState(0);
    const [editresponsehdrid, setEditresponsehdrid] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedQuoteDetails, setSelectedQuoteDetails] = useState([]);
    function a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    }

    const handleChangeIndex = (index) => {
        setValue(index);
    };


    const callMessage = (serverityval, msg, title) => {
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };

    const callError = (serverityval, msg, title) => {
        // Update state with error message        
        setParentRollSeverityvalue(serverityval);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(title);
        setParentRollMsgOpen(true);
    };


    // List of Parameter
    const [customerNotes, setCustomerNotes] = useState('');
    const [purchaseDate, setPurchasedDate] = useState(dayjs());
    const [tableRows, setTableRows] = useState([{ id_request_det: 1, material_code: '', material_description: '', quantity_approved: 0, quantity_issued: 0, quantity_balance: 0, quantity_to_issue: 0, delivery_date: '', uom: '', vendor_list: [] }]);


    // get party list
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(0);
    const { requestIndentNumberList, setRequestIndentNumberList, selectedRequestIndentNumberList, selectedRequestIndentNumberListID, setSelectedRequestIndentNumberList, setSelectedRequestIndentNumberListID, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(0);
    //const { RequestIndentDetail, loadIssueDetailByRequestIndentID, } = useLoadIssueDetailByRequestNumber();
    const { purchaseIndentNumber, setPurchaseIndentNumber, loadPurchaseIndentNumberByID } = usePurchaseIndentNumber(0);
    const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID, } = useEmployee(editPurchaseIndentID);

    const { processIndent } = useVendorEnquiryCRUD(callMessage);

    const { VendorEnquiryDetails, loadVendorDetailByVendorID, } = useLoadVendorEnquiryDetailByVendor();
    const [allPOData, setAllPOData] = useState({});

    const [editMode, setEditMode] = useState(false);
    const [enquiryReportData, setEnquiryReportData] = useState([]);
    const callback = () => {
        handlecallback();
    }

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });

    const [isLoadEditPO, setLoadEditPO] = useState(false);

    const removeVendorFromMaterial = (materialId, vendorId) => {
        setTableRows(prev =>
            prev.map(row =>
                row.id_material === materialId
                    ? {
                        ...row,
                        vendor_list: row.vendor_list.filter(v => v.id !== vendorId)
                    }
                    : row
            )
        );
    };


    const normalizeVendorList = (vendor_list) => {
        try {
            if (!vendor_list) return [];
            if (Array.isArray(vendor_list)) return vendor_list;
            return JSON.parse(vendor_list);
        } catch (e) {
            console.error("Invalid vendor_list JSON", vendor_list);
            return [];
        }
    };

    const extractVendorsFromMaterials = (rows) => {
        const vendorMap = new Map();

        rows.forEach(row => {
            row.vendor_list.forEach(v => {
                if (!vendorMap.has(v.id)) {
                    vendorMap.set(v.id, {
                        vendorId: v.id,
                        vendor: {
                            id: v.id,
                            name: v.name,
                            companyname: v.companyname,
                            email: v.email,
                            status: v.status
                        }
                    });
                }
            });
        });

        return Array.from(vendorMap.values());
    };



    useEffect(() => {
        if (VendorEnquiryDetails && VendorEnquiryDetails?.length > 0) {

            const normalizedRows = VendorEnquiryDetails.map(row => ({
                ...row,
                vendor_list: normalizeVendorList(row.vendor_list)
            }));

            setTableRows(normalizedRows);




            if (editPurchaseIndentID === 0) {
                try {
                    const fetchData = async () => {
                        const para = {
                            p_companyid: localStorage.getItem("companyid"),
                            p_plantid: 1,
                            p_material_list: VendorEnquiryDetails,
                        };

                        const purchaseOrderResponse = await callApi(API_ENDPOINTS.VENDOR_GET_VENDOR_DETAIL_BY_MATERIAL, 'POST', { 'Content-Type': 'application/json' }, para);
                        const purchaseOrder = purchaseOrderResponse[0];

                        if (purchaseOrder) {

                            const parsedVendors = JSON.parse(purchaseOrder.vendor_details);

                            if (parsedVendors && parsedVendors.length > 0) {
                                setVendors(parsedVendors);
                            }
                            else {
                                // 🔥 now populate vendors state
                                const vendorData = extractVendorsFromMaterials(normalizedRows);
                                setVendors(vendorData);

                            }
                        }
                    };

                    fetchData();
                } catch (error) {
                    callMessage('error', error.message, 'Error');
                }
            }
        }

    }, [VendorEnquiryDetails])


    useEffect(() => {
        const vendorData = extractVendorsFromMaterials(tableRows);
        setVendors(vendorData);
    }, [tableRows]);


    useEffect(() => {
        if (idRequestIndent !== 0 && idRequestIndent !== undefined) {
            loadDepartmentByID(idDepartment);
            //loadVendorDetailByVendorID(idRequestIndent, purchaseIndentNumber);
            loadIndentNumbersByDepartmentID(idDepartment, 'vendor enquiry', idRequestIndent);
            setSelectedRequestIndentNumberListID(idRequestIndent);
            setEditMode(false);
            loadEmployeeByID(idRequestIndent);

            getRequestDetailByRequestID(idRequestIndent);
        }
    }, [idRequestIndent, idDepartment]);

    useEffect(() => {

        if (!isLoadEditPO && editPurchaseIndentID !== 0 && idRequestIndent === undefined) {
            setEditMode(true);
            try {
                const fetchData = async () => {
                    const para = {
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_id_enquiry: editPurchaseIndentID,
                    };

                    const purchaseOrderResponse = await callApi(API_ENDPOINTS.VENDOR_ENQUIRY_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
                    const purchaseOrder = purchaseOrderResponse[0];

                    if (purchaseOrder) {
                        // setPurchaseIndentNumber(purchaseOrder.purchase_indent_number);
                        setPurchasedDate(purchaseOrder.enquiry_date);
                        setCustomerNotes(purchaseOrder.remarks);
                        setRequestedDate(purchaseOrder.enquiry_date);

                        const parsedVendors = JSON.parse(purchaseOrder.vendor_details);
                        setVendors(parsedVendors);
                        //setVendors(purchaseOrder.vendor_list);
                        await loadDepartmentByID(purchaseOrder.id_department);
                        await loadVendorDetailByVendorID(purchaseOrder.id_enquiry, purchaseOrder.id_purchase);
                        await loadIndentNumbersByDepartmentID(purchaseOrder.id_department, 'vendor enquiry', purchaseOrder.id_purchase)
                        setAllPOData(purchaseOrder);

                        await loadEmployeeByID(purchaseOrder.id_party);



                    }
                };

                fetchData();
            } catch (error) {
                callMessage('error', error.message, 'Error');
            }
        }

    }, [isLoadEditPO, editPurchaseIndentID]);


    useEffect(() => {

        if (!isLoadEditPO && editPurchaseIndentID !== 0 && idRequestIndent === undefined) {

            try {
                const fetchData = async () => {
                    const para = {
                        p_companyid: localStorage.getItem("companyid"),
                        p_plantid: 1,
                        p_id_enquiry: editPurchaseIndentID,
                    };

                    const purchaseOrderResponse = await callApi(API_ENDPOINTS.VENDOR_GET_REPORT_VENDOR_ENQUIRY_DETAIL_ENQUIRY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
                    const purchaseOrder = purchaseOrderResponse[0].usp_vendor_get_report_vendor_enquiries;

                    if (purchaseOrder) {
                        const parsedVendors = JSON.parse(purchaseOrder);
                        setEnquiryReportData(parsedVendors);


                    }
                };

                fetchData();
            } catch (error) {
                callMessage('error', error.message, 'Error');
            }
        }

    }, [isLoadEditPO, editPurchaseIndentID]);

    useEffect(() => {
        const missing = tableRows.find(r => r.vendor_list.length === 0);
        if (missing) setOpenRow(missing.id_material);
    }, [tableRows]);




    // useEffect(() => {
    //     if (editPurchaseIndentID === 0) {
    //         try {
    //             const fetchData = async () => {
    //                 const para = {
    //                     p_companyid: localStorage.getItem("companyid"),
    //                     p_plantid: 1,
    //                     p_id_enquiry: editPurchaseIndentID,
    //                 };

    //                 const purchaseOrderResponse = await callApi(API_ENDPOINTS.VENDOR_ENQUIRY_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
    //                 const purchaseOrder = purchaseOrderResponse[0];

    //                 if (purchaseOrder) {
    //                     // setPurchaseIndentNumber(purchaseOrder.purchase_indent_number);
    //                     setPurchasedDate(purchaseOrder.enquiry_date);
    //                     setCustomerNotes(purchaseOrder.remarks);

    //                     const parsedVendors = JSON.parse(purchaseOrder.vendor_details);
    //                     setVendors(parsedVendors);
    //                 }
    //             };

    //             fetchData();
    //         } catch (error) {
    //             callMessage('error', error.message, 'Error');
    //         }
    //     }
    // }, [editPurchaseIndentID]);

    const handleLoadPurchaseIndentDetails = (editPurchaseIndentIDNew) => {
        try {
            const fetchData = async () => {

                const para = {
                    p_companyid: localStorage.getItem("companyid"),
                    p_plantid: 1,
                    p_id_purchase: editPurchaseIndentIDNew,
                };

                const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHASED_INDENT_GET_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, para);
                const purchaseOrder = purchaseOrderResponse[0];

                if (purchaseOrder) {
                    setPurchaseIndentNumber(purchaseOrder.purchase_indent_number);
                    if (purchaseOrder.status === 'Enquiry Created') {
                        callMessage('warning', 'An enquiry has already been raised for this Purchase Indent.', 'Validation');
                        setEnquiryAllowed(false);
                    }
                    else {
                        setEnquiryAllowed(true);
                        setParentRollMsgOpen(false);
                    }
                    setPurchasedDate(purchaseOrder.purchase_date);

                    await loadEmployeeByID(purchaseOrder.id_requester);
                    await loadDepartmentByID(purchaseOrder.id_department);

                    if (editPurchaseIndentID > 0) {
                        await loadVendorDetailByVendorID(purchaseOrder.id_enquiry);
                    }

                    await loadIndentNumbersByDepartmentID(purchaseOrder.id_department, 'vendor enquiry', purchaseOrder.id_enquiry)
                    setAllPOData(purchaseOrder);

                    if (purchaseOrder.status === 'Enquiry Raised') {
                        setEnquiryAllowed(false);
                    }
                }
                else {
                    setPurchaseIndentNumber(null);
                    setEnquiryAllowed(true);
                    setParentRollMsgOpen(false);
                    setPurchasedDate(null);

                    await loadEmployeeByID(null);
                    await loadDepartmentByID(null);
                    await loadVendorDetailByVendorID(null);
                    await loadIndentNumbersByDepartmentID(null, 'vendor enquiry', null)
                    setAllPOData([]);
                    setTableRows([]);
                    setVendors([]);



                }
            };

            fetchData();
        } catch (error) {
            callMessage('error', error.message, 'Error');
        }
    }


    const getRequestDetailByRequestID = async (id_request) => {

        await loadVendorDetailByVendorID(0, id_request);
        handleLoadPurchaseIndentDetails(id_request);


    }

    const handleQuantityChange = (index, quantity) => {
        setTableRows((prevRows) => {
            return prevRows.map((row, i) => {
                if (i === index) {
                    return row.quantity_balance < quantity
                        ? row  // Return unchanged row if condition is not met
                        : { ...row, quantity_to_issue: quantity }; // Create a new object for state change detection
                }
                return row;
            });
        });
    };



    const handleSaveAndDraft = async () => {

        const modifiedRows = tableRows.map(({ material_code, material_description, ...rest }) => rest);


        if (!selectedDepartmentID || selectedDepartmentID === 0) {
            callError('warning', 'Department is required', 'Validation');
            return;
        }

        if (selectedRequestIndentNumberListID === 0 || selectedRequestIndentNumberListID === undefined) {

            callError('warning', 'Purchase Indent Number is required', 'Validation');
            return;
        }

        if (!selectedEmployeeID || selectedEmployeeID === 0) {
            callError('warning', 'Requested by is required', 'Validation');
            return;
        }

        if (!requestedDate || requestedDate === null) {
            callError('warning', 'Requested Date is required', 'Validation');
            return;
        }


        if (modifiedRows.length === 0 || modifiedRows[0].id_material === 0) {
            callError('warning', 'At least one item is required in the request indent', 'Validation');
            return;
        }

        // if (!vendors || vendors.length === 0 || vendors[0].vendorId === '') {
        //     callMessage('warning', "Please add vendors before saving.", 'Warning');
        //     return;
        // }

        const invalidMaterials = tableRows.filter(
            r => !r.vendor_list || r.vendor_list.length === 0
        );

        if (invalidMaterials.length > 0) {
            callMessage(
                'error',
                'Some materials have no vendors. Please assign at least one vendor.',
                'Validation Error'
            );
            return;
        }


        const vendorList = tableRows.flatMap(row =>
            (row.vendor_list || []).map(v => ({
                vendorId: v.id,
                id_material: row.id_material
            }))
        );


        let mode_id = 0;
        if (editPurchaseIndentID !== 0) {
            mode_id = 1;
        }
        let id_request = editPurchaseIndentID !== 0 ? editPurchaseIndentID : 0;

        const requestBody = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_id_enquiry: id_request,
            p_id_purchase: selectedRequestIndentNumberListID,
            p_mode: mode_id,
            p_id_department: selectedDepartmentID,
            p_status: 'Pending',
            p_remarks: customerNotes,
            p_enquiryitem_list: modifiedRows,
            p_vendor_list: vendorList,
            p_enquiry_date: dayjs(requestedDate).format('YYYY-MM-DD hh:mm:ss'),
            p_id_party: selectedEmployeeID,

        }
        const isSuccess = await processIndent(
            selectedMode,
            editPurchaseIndentID,
            requestBody
        );

        if (isSuccess) {
            setEnquiryAllowed(false); // 🔥 only on success
        }
        // processIndent(selectedMode, editPurchaseIndentID, requestBody);

        // setEnquiryAllowed(false);

    };

    const handleClear = () => {
        setSelectedDepartment(null);
        setSelectedDepartmentID(null);
        setSelectedRequestIndentNumberList(null);
        setSelectedRequestIndentNumberListID(null);
        getRequestDetailByRequestID(null);
        loadIndentNumbersByDepartmentID(null, 'vendor enquiry');
        setRequestIndentNumberList([]);
        setCustomerNotes('');
    }

    const handleDateChange = (index, date) => {
        const newRows = [...tableRows];
        newRows[index].delivery_date = date ? date.format('YYYY-MM-DD') : '';  // Format date correctly
        setTableRows(newRows);
    };

    const handleSendEmail = async (to, cc) => {
        try {
            const response = await callApi(API_ENDPOINTS.SEND_EMAIL, 'POST', { 'Content-Type': 'application/json' }, {
                to,
                cc,
                subject: `Purchase Order ${allPOData.purchaseOrderNumber}`,
                body: JSON.stringify(allPOData) // This could be formatted as HTML for better presentation
            });

            if (response.success) {
                alert('Email sent successfully');
            } else {
                alert('Failed to send email');
            }
        } catch (error) {
            callError('error', error.message, 'Error');
        }
    };
    const buildEnquiryFromReport = (reportDataList) => {
        return {
            enquiryNo: "ENQ-1023",
            vendors: reportDataList.map(r => ({
                name: `${r.receivername} - ${r.receivercompanyname}`,
                email: r.email,
                materials: r.materials
            }))
        };
    };

    const getUniqueVendorsFromReport = (reportDataList) => {
        const map = new Map();

        reportDataList.forEach(r => {
            if (!map.has(r.email)) {
                map.set(r.email, {
                    name: `${r.receivername} - ${r.receivercompanyname}`,
                    email: r.email,
                    materials: r.materials
                });
            } else {
                // merge materials if same vendor appears again
                const existing = map.get(r.email);
                map.set(r.email, {
                    ...existing,
                    materials: [...existing.materials, ...r.materials]
                });
            }
        });

        return Array.from(map.values());
    };

    const buildEnquiry = (reportDataList) => {
        const uniqueMap = new Map();

        reportDataList.forEach(r => {
            if (!uniqueMap.has(r.email)) {
                uniqueMap.set(r.email, {
                    name: `${r.receivername} - ${r.receivercompanyname}`,
                    email: r.email,
                    materials: r.materials,
                    employee_email: r.employee_email,
                    employee_workphone: r.employee_workphone
                });
            }
        });

        return {
            enquiryNo: "ENQ-1023",
            vendors: Array.from(uniqueMap.values())
        };
    };




    const [enquirylist, setenquirylist] = useState([]);

    const handlecallProcess = async (buttonName) => {
        if (buttonName === 'Email') {
            setOpenPreviewModal(true);
            setOpenVendorEnquiry(false);
            try {

                const enquiry = buildEnquiry(enquiryReportData);
                setenquirylist(enquiry);
            }
            catch (error) {
                console.error("Unable to send mail :", error);
            }


        } else if (buttonName === 'VendorQuotation') {
            setOpenVendorQuotation(true);
            setOpenVendorEnquiry(false);
        }

        else if (buttonName === 'PDF') {
            try {

                const seenVendors = new Set();
                for (const vendor of enquiryReportData) {
                    const key = vendor.receivercompanyname?.trim().toLowerCase(); // or use vendor.id 

                    if (seenVendors.has(key)) {
                        continue; // Skip duplicate
                    }
                    const doc = <MultiVendorEnquiryPDF vendors={[vendor]} />;
                    const blob = await pdf(doc).toBlob();
                    const filename = `Vendor_Enquiry_${vendor.receivercompanyname.replace(/\s+/g, '_')}.pdf`;
                    saveAs(blob, filename);

                    seenVendors.add(key);
                }


            } catch (error) {
                console.error("PDF generation failed:", error);
            }
        }
        else if (buttonName === 'SupplierQuotation') {
            setOpenVendorQuotation(true);
            setOpenVendorEnquiry(false);
            setEditpurchaseindentID(editPurchaseIndentID);
        }
    };


    const handlecallbacktoVendor = () => {
        setOpenVendorQuotation(false);
        setOpenVendorEnquiry(true);
    }

    const handlecallbacktoVendorEnquiry = () => {
        setOpenPreviewModal(false);
        setOpenVendorEnquiry(true);
        setOpenVendorQuotation(false);
    }
    useEffect(() => {
        const missing = tableRows.find(r => !r.vendor_list?.length);
        if (missing) setOpenRow(missing.id_material);
    }, [tableRows]);


    return (<>

        {openVendorEnquiry && (


            <Box padding={0}>

                <Header title={editPurchaseIndentID === 0 ? 'New Vendor Enquiry' : 'Edit Vendor Enquiry'} subtitle="" callback={callback} />
                <Divider />
                {editPurchaseIndentID > 0 && (
                    <>
                        <VendorEnquiryActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
                        <Divider />
                    </>
                )}

                <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                    setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                    setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        px: 1,
                        py: 1
                    }}
                >
                    <Typography variant="h6"  >
                        <span style={{ color: 'red' }}>*</span> Mandatory fields
                    </Typography>
                </Box>
                <Box
                    sx={{
                        padding: "5px",
                        borderRadius: "10px",
                        maxHeight: {
                            xs: '72vh', // Extra small devices (phones)
                            sm: '72vh', // Small devices (tablets)
                            md: '74vh', // Medium devices (small laptops)
                            lg: '74vh', // Large devices (desktops)
                            xl: '82vh', // Extra large devices (large desktops)
                        },
                        overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                        '&::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: colors.primary[400],
                            borderRadius: '10px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: colors.blueAccent[600],
                            borderRadius: '10px',
                            '&:hover': {
                                background: colors.blueAccent[800],
                            },
                        },
                        '&::-webkit-scrollbar-corner': {
                            background: colors.primary[700],
                        }
                    }}>

                    <Grid container  >

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="15px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Department <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={department}
                                        value={selectedDepartment}
                                        disabled={editMode}
                                        onChange={(event, newValue) => {
                                            if (newValue === null) {
                                                setSelectedDepartment(null);
                                                setSelectedDepartmentID(null);

                                                setSelectedRequestIndentNumberList(null);
                                                setSelectedRequestIndentNumberListID(null);
                                                getRequestDetailByRequestID(null);
                                                loadIndentNumbersByDepartmentID(null, 'vendor enquiry');
                                                setRequestIndentNumberList([]);

                                            }
                                            else {
                                                setSelectedDepartment(newValue);
                                                setSelectedDepartmentID(newValue.id);
                                                loadIndentNumbersByDepartmentID(newValue.id, 'vendor enquiry');
                                            }
                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Tooltip title={!EnquiryAllowed ? 'Enquiry has already been raised for this indent' : ''} arrow>

                                        <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                            Purchase Indent # <span style={{ color: 'red' }}>*</span>
                                        </Typography>
                                    </Tooltip>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={requestIndentNumberList}
                                        value={selectedRequestIndentNumberList}
                                        disabled={editMode}
                                        onChange={(event, newValue) => {
                                            if (newValue === null) {
                                                setSelectedRequestIndentNumberList(null);
                                                setSelectedRequestIndentNumberListID(null);
                                                getRequestDetailByRequestID(null);
                                            }
                                            else {
                                                setSelectedRequestIndentNumberList(newValue);
                                                setSelectedRequestIndentNumberListID(newValue.id_request);
                                                getRequestDetailByRequestID(newValue.id_request);
                                            }

                                        }}
                                        getOptionLabel={(option) => option.request_indent_number || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={5} lg={5} xl={5} display="flex-start" justifyContent="center">
                                    {!EnquiryAllowed && (
                                        <Typography
                                            variant="h6"
                                            fontSize={12}
                                            //   fontWeight="bold"
                                            marginTop={0}
                                            textAlign="left"
                                            sx={{
                                                display: 'inline-block',
                                                backgroundColor: theme.palette.mode === 'dark'
                                                    ? theme.palette.grey[800]
                                                    : theme.palette.grey[300],
                                                color: theme.palette.text.primary,
                                                padding: '6px 10px',
                                                borderRadius: '4px',
                                                boxShadow: theme.shadows[2],
                                                fontFamily: 'Arial, sans-serif',
                                                maxWidth: '300px',
                                            }}
                                        >
                                            ( Enquiry has already been raised for this Purchase Indent. )
                                        </Typography>
                                    )}


                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Requested By <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>



                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={employee}
                                        value={selectedEmployee}
                                        onChange={(event, newValue) => {
                                            if (newValue === null) {
                                                setSelectedEmployee(null);
                                                setSelectedEmployeeID(null);
                                                return;
                                            }
                                            setSelectedEmployee(newValue);
                                            setSelectedEmployeeID(newValue.id);
                                        }}
                                        getOptionLabel={(option) => option.name || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" color='secondary' required variant="outlined" />
                                        )}
                                    />
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                        Requested Date <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2.8} lg={2.8} xl={2.8}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2}>
                                            <DatePicker
                                                size="small"
                                                id="requestedDate"
                                                value={dayjs(requestedDate)}
                                                onChange={(date) => setRequestedDate(date)}
                                                slotProps={{ textField: { size: 'small', color: 'secondary' } }}
                                                fullWidth
                                                format="DD-MMM-YYYY" // 👈 Format set here
                                                className="customDatePicker"
                                                renderInput={(props) => (
                                                    <TextField required {...props} />
                                                )}
                                            />
                                        </Stack>
                                    </LocalizationProvider>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid item xs={12} lg={12} xl={12} mt={12} >
                            <Grid container padding="0px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                                    <Typography variant="h5"> Material Details :</Typography>
                                    <CustomTableContainer colors={colors}>


                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell width={40}></TableCell>

                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Material Code</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Name</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>UOM</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Requested</TableCell>
                                                        <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Available In Store</TableCell>
                                                        {editPurchaseIndentID == 0 ?
                                                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Required</TableCell>
                                                            : <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Current Required</TableCell>}

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows.map((row, index) => (
                                                        <React.Fragment key={index}>
                                                            <TableRow>
                                                                <TableCell style={{ textAlign: 'center' }}>
                                                                    <Tooltip title="View Vendors" arrow>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() =>
                                                                                setOpenRow(openRow === row.id_material ? null : row.id_material)
                                                                            }
                                                                        >
                                                                            {openRow === row.id_material ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </TableCell>



                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'center',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="text"
                                                                        value={`${row.material_code} `}
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'center',
                                                                            },
                                                                        }}
                                                                        value={row.material_description}
                                                                        variant="outlined"
                                                                        disabled
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'center',
                                                                            },
                                                                        }}
                                                                        value={row.uom}
                                                                        variant="outlined"
                                                                        disabled
                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        value={row.quantity_required}

                                                                    />
                                                                </TableCell>

                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        value={row.quantity_available}
                                                                    />
                                                                </TableCell>
                                                                <TableCell style={{ size: "small", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        disabled
                                                                        size="small"
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                padding: '8px',
                                                                                textAlign: 'right',
                                                                            },
                                                                        }}
                                                                        variant="outlined"
                                                                        type="number"
                                                                        value={row.quantity_required}
                                                                    />
                                                                </TableCell>


                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell
                                                                    colSpan={7} // adjust based on your column count (+1 for expand column)
                                                                    style={{ paddingBottom: 0, paddingTop: 0 }}
                                                                >
                                                                    <Collapse in={openRow === row.id_material} timeout="auto" unmountOnExit>
                                                                        <Box sx={{ margin: 1 }}>
                                                                            <Typography variant="subtitle2" gutterBottom>
                                                                                Vendors
                                                                            </Typography>

                                                                            {row.vendor_list?.length > 0 ? (
                                                                                row.vendor_list.map(v => (
                                                                                    <Chip
                                                                                        key={v.id}
                                                                                        label={v.companyname}
                                                                                        size="small"
                                                                                        color="secondary"
                                                                                        onDelete={() => removeVendorFromMaterial(row.id_material, v.id)}
                                                                                        sx={{ mr: 0.5, mb: 0.5 }}
                                                                                    />




                                                                                ))
                                                                            ) : (
                                                                                <Typography color="error" variant="caption">
                                                                                    No vendors mapped for this material
                                                                                </Typography>
                                                                            )}
                                                                        </Box>
                                                                    </Collapse>
                                                                </TableCell>
                                                            </TableRow>

                                                        </React.Fragment>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </CustomTableContainer>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                                <Grid item xs={12} sm={12} md={5} lg={7} xl={5} display="flex-start" justifyContent="center">
                                    <Box mt={1}  >

                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <Tabs
                                                value={value}
                                                onChange={handleChange}
                                                indicatorColor="secondary"
                                                textColor="inherit"
                                                variant="contained"
                                                aria-label="full width tabs example"
                                            >
                                                <Tab sx={{ textTransform: "none" }} label="Vendors List" {...a11yProps(0)} />

                                            </Tabs>
                                        </Box>

                                        <SwipeableViews
                                            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                            index={value}
                                            onChangeIndex={handleChangeIndex}
                                        >
                                            <TabPanel value={value} index={0} dir={theme.direction}>
                                                <Box>
                                                    <MaterialWiseVendor vendors={vendors} setVendors={setVendors} disableRemoveContact={true} />
                                                </Box>
                                            </TabPanel>
                                        </SwipeableViews>
                                    </Box>

                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid item xs={12} lg={12} xl={12} mt={1} padding={2} >
                            <Box padding={1} sx={{
                                display: 'flex',
                                alignItems: 'center',
                                borderColor: 'divider',
                                borderRadius: 2,
                                color: 'text.secondary', '& svg': { m: 1, },
                            }} >
                                <Grid container spacing={0}>
                                    <Grid item xs={6} lg={6.4} xl={6} marginRight={1}>
                                        <Typography variant="h5" fontWeight="bold">Notes </Typography>
                                        <Grid item xs={12} lg={12} xl={10}>
                                            <TextField
                                                id="outlined-multiline-static"
                                                value={customerNotes}
                                                onChange={(e) => setCustomerNotes(e.target.value)}
                                                placeholder="Enter the issuer notes , will appear the issue indent."
                                                multiline
                                                color="secondary"
                                                rows={4}
                                                fullWidth
                                                variant="outlined"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>

                    </Grid>
                </Box>




                <Grid container>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                            <Toolbar>

                                <Button size="small" disabled={!EnquiryAllowed} variant="contained" color="secondary" onClick={handleSaveAndDraft} startIcon={<SaveAltIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save Enquiry</Button>


                                <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} onClick={handleClear} sx={{ marginLeft: '5px', textTransform: 'none' }}>Clear</Button>
                            </Toolbar>
                        </Box>
                    </Grid>
                </Grid>

            </Box>
        )}
        {/* <PreviewPurchaseIndentEmail
            open={openPreviewModal}
            onClose={() => setOpenPreviewModal(false)}
            onSend={handleSendEmail}
            poData={allPOData}
        /> */}


        {(openVendorQuotation) && (
            <AddVendorReponseNew handlecallback={handlecallbacktoVendorEnquiry} editIssueIndentID={editIssueIndentID} para_selectedDepartment={selectedDepartment} para_selectedPurchaseIndentNo={selectedRequestIndentNumberList} selectedRows={selectedRows} selectedpurchaseindentID={editpurchaseindentID} editresponsehdrid={editresponsehdrid} selectedQuoteDetails={selectedQuoteDetails} fromVendorEnquiryUI={true} />
        )}
    
        {(openPreviewModal) && (
            <VendorEnquiryMail enquiry={enquirylist} handlecallbacktoVendorEnquiry={handlecallbacktoVendorEnquiry} enquiryNo={editPurchaseIndentID} enquiryReportData={enquiryReportData} />
        )}

    </>)
}
export default AddNewVendorEnquiry;